import apiClient, { shouldUseAPI, handleAPIError } from './apiClient';

const catalogsService = {
  getMockCatalogs() {
    return {
      categories: [
        { id: 1, name: 'Emergencia', parent: null, is_leaf: false },
        { id: 2, name: 'Mantenimiento', parent: null, is_leaf: false }
      ],
      channels: [
        { id: '140', name: 'Urgencias 140' },
        { id: 'web', name: 'Web' },
        { id: 'telefonico', name: 'Telefonico' },
        { id: 'email', name: 'Email' }
      ],
      requirements_by_channel: {
        '140': ['location'],
        web: [],
        telefonico: [],
        email: []
      }
    };
  },

  async getCatalogs() {
    if (!shouldUseAPI()) {
      return this.getMockCatalogs();
    }

    try {
      const categoriesRes = await apiClient.get('/api/categories/?parent__isnull=true');
      return {
        categories: categoriesRes.data.results || [],
        channels: [
          { id: '140', name: 'Urgencias 140' },
          { id: 'web', name: 'Web' },
          { id: 'telefonico', name: 'Telefonico' },
          { id: 'email', name: 'Email' }
        ],
        requirements_by_channel: {
          '140': ['location'],
          web: [],
          telefonico: [],
          email: []
        }
      };
    } catch (error) {
      const apiError = handleAPIError(error);
      if (apiError) throw apiError;
      throw error;
    }
  },

  async getCategoriesByParent(parentId) {
    if (!shouldUseAPI()) {
      return [];
    }

    try {
      const response = await apiClient.get(`/api/categories/?parent=${parentId}`);
      return response.data.results || [];
    } catch (error) {
      const apiError = handleAPIError(error);
      if (apiError) throw apiError;
      throw error;
    }
  },

  async getFormsByCategory(categoryId) {
    if (!shouldUseAPI()) {
      return [];
    }

    try {
      const response = await apiClient.get(`/api/categories/${categoryId}/forms/`);
      return response.data || [];
    } catch (error) {
      const apiError = handleAPIError(error);
      if (apiError) throw apiError;
      throw error;
    }
  },

  async getFieldsSchema(categoryId, formId) {
    if (!shouldUseAPI()) {
      return {
        form_id: formId,
        category_id: categoryId,
        sections: []
      };
    }

    try {
      const response = await apiClient.get(
        `/api/categories/${categoryId}/fields-schema/?form_id=${formId}`
      );
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      if (apiError) throw apiError;
      throw error;
    }
  },

  channelRequiresLocation(channelId, requirementsByChannel) {
    return requirementsByChannel[channelId]?.includes('location') || false;
  }
};

export default catalogsService;
